function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import classNames from "classnames";
import UICollapse from "./ui/UICollapse";
import Icon from "./Icon";
import { injectIntl } from "react-intl";
var AppMenuSearchResult = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(AppMenuSearchResult, PureComponent);
    var _super = _createSuper(AppMenuSearchResult);
    function AppMenuSearchResult() {
        _classCallCheck(this, AppMenuSearchResult);
        var _this;
        _this = _super.apply(this, arguments);
        _this.renderChart = function(chart) {
            var _this_props = _this.props, isAvailable = _this_props.isAvailable, isCompleted = _this_props.isCompleted, goTo = _this_props.goTo, currentSlide = _this_props.currentSlide;
            var isVisited = isCompleted(chart.id);
            var available = isAvailable(chart);
            var slideClasses = classNames("chart-menu__item", {
                "chart-status__visited": isVisited,
                "chart-status__not-visited": !isVisited,
                "chart-status__not-available": !available
            });
            var linkClasses = classNames("chart-menu__link", {
                "chart-menu__link--active": currentSlide === chart.id,
                "chart-menu__link--do-not-track": chart.do_not_track,
                "chart-menu__link--disabled": !available
            });
            var visClasses = classNames("chart-menu__visited", {
                "chart-menu__visited--active": isVisited
            });
            return /*#__PURE__*/ React.createElement("li", {
                className: slideClasses,
                key: chart.id
            }, !chart.do_not_track && /*#__PURE__*/ React.createElement("div", {
                className: visClasses
            }, /*#__PURE__*/ React.createElement(Icon, {
                name: "checkmark-bold",
                size: "s"
            })), /*#__PURE__*/ React.createElement("a", {
                className: linkClasses,
                href: "#?chart=".concat(chart.id),
                disabled: !available,
                onClick: function(evnt) {
                    evnt.preventDefault();
                    evnt.stopPropagation();
                    goTo(chart.id);
                },
                dangerouslySetInnerHTML: {
                    __html: chart.name
                }
            }));
        };
        _this.renderNotes = function(note) {
            var openNote = _this.props.openNote;
            return /*#__PURE__*/ React.createElement("li", {
                className: "chart-menu__item",
                key: note.id
            }, /*#__PURE__*/ React.createElement("a", {
                className: "chart-menu__link",
                href: "?note=".concat(note.id),
                onClick: function(evnt) {
                    evnt.preventDefault();
                    evnt.stopPropagation();
                    openNote(note);
                },
                dangerouslySetInnerHTML: {
                    __html: note.title
                }
            }));
        };
        _this.renderTopics = function(topic) {
            var openTopic = _this.props.openTopic;
            return /*#__PURE__*/ React.createElement("li", {
                className: "chart-menu__item",
                key: topic.id
            }, /*#__PURE__*/ React.createElement("a", {
                className: "chart-menu__link",
                href: "?topic=".concat(topic.id),
                onClick: function(evnt) {
                    evnt.preventDefault();
                    evnt.stopPropagation();
                    openTopic(topic);
                },
                dangerouslySetInnerHTML: {
                    __html: topic.title
                }
            }));
        };
        _this.renderBonus = function(bonus) {
            var _this_props = _this.props, openBonus = _this_props.openBonus, getSlideStateByBonus = _this_props.getSlideStateByBonus;
            var _getSlideStateByBonus = _slicedToArray(getSlideStateByBonus(bonus), 3), available = _getSlideStateByBonus[0], isVisited = _getSlideStateByBonus[1], slideId = _getSlideStateByBonus[2];
            var linkClasses = classNames("chart-menu__link", {
                "chart-menu__link--disabled": !available
            });
            var slideClasses = classNames("chart-menu__item", {
                "chart-status__visited": isVisited,
                "chart-status__not-visited": !isVisited,
                "chart-status__disabled": !available
            });
            return /*#__PURE__*/ React.createElement("li", {
                className: slideClasses,
                key: bonus.id
            }, /*#__PURE__*/ React.createElement("a", {
                className: linkClasses,
                href: "?bonus=".concat(bonus.id),
                onClick: function(evnt) {
                    evnt.preventDefault();
                    evnt.stopPropagation();
                    openBonus(bonus.id, slideId, available);
                },
                dangerouslySetInnerHTML: {
                    __html: bonus.name
                }
            }));
        };
        _this.resultsText = function(count) {
            var intl = _this.props.intl;
            return "".concat(count, " ").concat(intl.formatMessage({
                id: "ui.search_result",
                defaultMessage: "found"
            }));
        };
        return _this;
    }
    var _proto = AppMenuSearchResult.prototype;
    _proto.render = function render() {
        var _this = this;
        var _results_slides, _results_notes, _results_community, _results_bm;
        var _this_props = this.props, results = _this_props.results, intl = _this_props.intl;
        if (!results) return null;
        var totalResults = results.slides.length + results.notes.length + results.community.length + results.bm.length;
        var totalResultsText = intl.formatMessage({
            id: "menu.total_results",
            defaultMessage: "{total} results found"
        }, {
            total: totalResults
        });
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
            className: "sr-only",
            role: "status"
        }, totalResultsText), /*#__PURE__*/ React.createElement("ul", {
            className: "app-menu__chapters"
        }, /*#__PURE__*/ React.createElement(UICollapse, {
            id: "searchResultContent",
            secondaryText: this.resultsText(results.slides.length),
            disabled: !(results === null || results === void 0 ? void 0 : (_results_slides = results.slides) === null || _results_slides === void 0 ? void 0 : _results_slides.length),
            primaryText: intl.formatMessage({
                id: "ui.search_content",
                defaultMessage: "Slides"
            })
        }, results && results.slides && results.slides.length ? results.slides.map(function(s) {
            return _this.renderChart(s);
        }) : null), /*#__PURE__*/ React.createElement(UICollapse, {
            id: "searchResultNotes",
            secondaryText: this.resultsText(results.notes.length),
            disabled: !(results === null || results === void 0 ? void 0 : (_results_notes = results.notes) === null || _results_notes === void 0 ? void 0 : _results_notes.length),
            primaryText: intl.formatMessage({
                id: "ui.search_notes",
                defaultMessage: "Notes"
            })
        }, ((results === null || results === void 0 ? void 0 : results.notes) || []).map(this.renderNotes)), /*#__PURE__*/ React.createElement(UICollapse, {
            id: "searchResultActivities",
            secondaryText: this.resultsText(results.community.length),
            disabled: !(results === null || results === void 0 ? void 0 : (_results_community = results.community) === null || _results_community === void 0 ? void 0 : _results_community.length),
            primaryText: intl.formatMessage({
                id: "ui.search_activities",
                defaultMessage: "Posts"
            })
        }, ((results === null || results === void 0 ? void 0 : results.community) || []).map(this.renderTopics)), /*#__PURE__*/ React.createElement(UICollapse, {
            id: "searchResultActivities",
            secondaryText: this.resultsText(results.bm.length),
            disabled: !(results === null || results === void 0 ? void 0 : (_results_bm = results.bm) === null || _results_bm === void 0 ? void 0 : _results_bm.length),
            primaryText: intl.formatMessage({
                id: "ui.search_bonus",
                defaultMessage: "Bonus Material"
            })
        }, ((results === null || results === void 0 ? void 0 : results.bm) || []).map(this.renderBonus))));
    };
    return AppMenuSearchResult;
}(PureComponent);
export default injectIntl(AppMenuSearchResult);
